var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 13.8C18 14.19 17.8518 14.4875 17.5553 14.6925C17.2588 14.8975 16.8949 15 16.4636 15H1.53639C1.10512 15 0.74124 14.895 0.444744 14.685C0.148248 14.475 0 14.18 0 13.8C0 13.5 0.097035 13.195 0.291105 12.885L7.74663 0.825C8.10243 0.275 8.52291 0 9.00809 0C9.49326 0 9.90296 0.275 10.2372 0.825L17.7089 12.9C17.903 13.22 18 13.52 18 13.8ZM10.124 6.135V3.945H7.87601V6.135C7.87601 6.275 7.88679 6.4075 7.90836 6.5325C7.92992 6.6575 7.95957 6.7975 7.9973 6.9525C8.03504 7.1075 8.06469 7.24 8.08625 7.35L8.50674 9.78H9.46092L9.89757 7.35C9.91914 7.25 9.95148 7.12 9.99461 6.96C10.0377 6.8 10.0701 6.6575 10.0916 6.5325C10.1132 6.4075 10.124 6.275 10.124 6.135ZM10.124 11.94C10.124 11.65 10.0135 11.405 9.79245 11.205C9.57143 11.005 9.30458 10.905 8.99191 10.905C8.69003 10.905 8.42857 11.005 8.20755 11.205C7.98652 11.405 7.87601 11.65 7.87601 11.94C7.87601 12.23 7.98652 12.4775 8.20755 12.6825C8.42857 12.8875 8.69003 12.99 8.99191 12.99C9.30458 12.99 9.57143 12.8875 9.79245 12.6825C10.0135 12.4775 10.124 12.23 10.124 11.94Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageWarning);
export default __webpack_public_path__ + "static/media/message-warning.0ffa26701168ddc78de11620eadf5752.svg";
export { ForwardRef as ReactComponent };